import moment from "moment";
import React, { useState } from "react";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import TicketEditGdsPnrModal from "../../../../components/modal/flight/TicketEditGdsPnrModal";
import TicketEditAirlinePnrModal from "../../../../components/modal/flight/TicketEditAirlinePnrModal";

function BookingConfirmationOrderIdContainer({
  order,
  bookingData,
  onUpdateTicket,
  updatedTicket,
}) {
  const data = order?.booking;
  const booking = updatedTicket || data?.flightBooking?.at(0);
  const [editGdsPnrOpen, setEditGdsPnrOpen] = useState(false);
  const [editAirlinePnrOpen, setEditAirlinePnrOpen] = useState(false);

  const pnrList =
    booking?.pnrList ??
    booking?.travelers?.at(0)?.pnrList ??
    booking?.flights?.map(() => ({ airlinePnr: "" })) ??
    [];
  const airlinePnr =
    pnrList
      .map((pnr) => (pnr?.airlinePnr || "")?.toLocaleUpperCase())
      .filter(Boolean)
      .join(" | ") || "—";

  const handleSaveGdsPnr = (newPnr) => {
    const flightBooking = updatedTicket || data?.flightBooking?.at(0);
    onUpdateTicket?.({ ...flightBooking, pnr: newPnr });
    setEditGdsPnrOpen(false);
  };

  const handleSaveAirlinePnr = (newPnrList) => {
    const flightBooking = updatedTicket || data?.flightBooking?.at(0);
    const travelers = (flightBooking?.travelers ?? []).map((t) => ({
      ...t,
      pnrList: newPnrList,
    }));
    onUpdateTicket?.({
      ...flightBooking,
      pnrList: newPnrList,
      travelers,
    });
    setEditAirlinePnrOpen(false);
  };

  const gdsPnrCell = (
    <div className="flex gap-1 items-center mt-1">
      <span className="text-sm text-gray-800">{booking?.pnr}</span>
      <IconButton
        size="small"
        aria-label="Edit GDS PNR"
        onClick={() => setEditGdsPnrOpen(true)}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    </div>
  );

  const airlinePnrCell = (
    <div className="flex gap-1 items-center mt-1">
      <span className="text-sm text-gray-800">{airlinePnr || "—"}</span>
      <IconButton
        size="small"
        aria-label="Edit Airline PNR"
        onClick={() => setEditAirlinePnrOpen(true)}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    </div>
  );

  return (
    <div className="w-full rounded-md border border-primary1/10 bg-primary1/5 mt-4">
      {/* Top blue rule */}
      <div className="h-1 w-full bg-primary1" />

      {/* Content */}
      <div className="p-3 sm:p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-4 items-start">
          <div>
            <div className="text-xs text-gray-500">Order date</div>
            <div className="mt-1 text-sm text-gray-800">
              {moment(data?.createdAt).format("MM/DD/YYYY  hh:mmA [GMT]Z")}
            </div>
          </div>
          <div className="grid lg:hidden w-full grid-cols-2">
            <div>
              <div className="text-xs text-gray-500">Order Id</div>
              <a
                target="_blank"
                rel="noreferrer"
                href={`/order/flight/ticket/detail/${booking?.bookingId}?page=Bookings`}
                className="mt-1 text-sm text-primary1 cursor-pointer hover:underline"
              >
                {booking?.bookingId}
              </a>
            </div>

            <div>
              <div className="text-xs text-gray-500">GDS PNR</div>
              {gdsPnrCell}
            </div>
          </div>

          <div className="hidden lg:flex flex-col">
            <div className="text-xs text-gray-500">Order Id</div>
            <a
              target="_blank"
              rel="noreferrer"
              href={`/order/flight/ticket/detail/${booking?.bookingId}?page=Bookings`}
              className="mt-1 text-sm text-primary1 cursor-pointer hover:underline"
            >
              {booking?.bookingId}
            </a>
          </div>

          <div className="hidden lg:flex flex-col">
            <div className="text-xs text-gray-500">GDS PNR</div>
            {gdsPnrCell}
          </div>

          <div>
            <div className="text-xs text-gray-500">Airline PNR</div>
            {airlinePnrCell}
          </div>
        </div>
      </div>

      <TicketEditGdsPnrModal
        open={editGdsPnrOpen}
        setOpen={setEditGdsPnrOpen}
        initialValue={booking?.pnr}
        handleSave={handleSaveGdsPnr}
      />
      <TicketEditAirlinePnrModal
        open={editAirlinePnrOpen}
        setOpen={setEditAirlinePnrOpen}
        initialPnrList={pnrList}
        handleSave={handleSaveAirlinePnr}
      />
    </div>
  );
}

export default BookingConfirmationOrderIdContainer;
